import { Box, Flex, Image } from "@chakra-ui/react";

import { Link } from "react-router-dom";
import "../../Styles/forIndore.css";
import Carousel from "react-multi-carousel";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Indoor = () => {
  return (
    <Box color={"#FFFFFF"}>
      {/* <Flex
        gap={7}
        alignItems={"center"}
        cursor={"pointer"}
        justifyContent={"space-between"}
      > */}
      <Carousel responsive={responsive} className="z-0">
        <Box w={{ base: "100%", md: "90%" }}>
          <Link to={"/indoorplant"}>
            <ImageZoom src={"https://images.wishfy.io/static/i3.jpg"} />
          </Link>
        </Box>

        <Box w={{ base: "100%", md: "90%" }}>
          <Link to={"/outdoorplant"}>
            <ImageZoom src={"https://images.wishfy.io/static/i2.png"} />
          </Link>
        </Box>

        <Box w={{ base: "100%", md: "90%" }}>
          <Link to={"/spiceplant"}>
            <ImageZoom src={"https://images.wishfy.io/static/i1.jpg"} />
          </Link>
        </Box>

        <Box w={{ base: "100%", md: "90%" }}>
          <Link to={"/fruitplant"}>
            <ImageZoom src={"https://images.wishfy.io/static/i6.jpg"} />
          </Link>
        </Box>
      </Carousel>
      {/* </Flex> */}
    </Box>
  );
};
const ImageZoom = ({ src }) => {
  const handleMouseEnter = (event) => {
    event.target.style.transform = "scale(1.05)";
    event.target.style.transition = "0.1s ease-in";
  };

  const handleMouseLeave = (event) => {
    event.target.style.transform = "scale(1)";
  };

  return (
    <Image
      src={src}
      w={"100%"}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
};
export default Indoor;
